module.exports = __webpack_public_path__ + "img/nrg_nrgsyndicate.2fe0d70.png";